module.exports = __webpack_public_path__ + "static/media/rsrcmtr_121.6ec74dc7.ico";